import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import sar from '../../static/images/sar-logo.png';
import car3d from '../../static/images/ar/car3d.png';
import endsars from '../../static/images/ar/endsars.png';
import pb from '../../static/images/ar/pixie_butterfly.png';
import uza from '../../static/images/ar/uzuriart.png';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: 500,
        padding: "20px",
        // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
        transform: 'translateZ(0)',
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, ' +
            'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
        color: 'white',
    },
    media: {
        height: 140,
    },
}));

const tileData = [
    {
        img: endsars,
        title: 'AR Filter',
        author: 'author',
        featured: true,
        details: 'This filter was created for the End Police Brutality cause in Nigeria, it lets you make a video while the icon is placed in the world or tracks your face',
        link: 'https://www.instagram.com/ar/807665139994302/'
    },
    {
        img: pb,
        title: 'AR Filter',
        author: 'author',
        details: 'This filter uses the face tracking technology to monitor your head shake and triggers the butterfly to fly around your face while dropping pixie dusts. ',
        link: 'https://www.instagram.com/ar/1034805106932729/'
    },
    {
        img: uza,
        title: 'AR Filter',
        author: 'author',
        details: 'This filter was created for an brand on instagram to promote their eyelashes business. The filter tracks the eye blinks to emit stars',
        link: 'https://www.instagram.com/ar/305964077287529/'
    },
    {
        img: car3d,
        title: 'AR Game',
        author: 'author',
        featured: true,
        details: 'This is an AR game that uses the head movement to control the movement of the car. You gain points when you collect coins and lose the game when you hit an obstacle',
        link: 'https://www.instagram.com/ar/348059553052198/'
    },
];

export default function AR() {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));
    const sz = () => {
        if(!matches) {
            return 2;
        }

        return 1;
    }

    return (
        <div className={classes.root}>
            <GridList cellHeight={"auto"} spacing={1} className={classes.gridList}>
                {tileData.map((tile) => (
                    <GridListTile key={tile.img} cols={tile.featured ? 2 : sz()} rows={tile.featured ? 2 : sz()}>
                        <Box mt={3} p={1}>
                            <Card >
                                <CardActionArea>
                                    <CardMedia
                                        className={classes.media}
                                        image={tile.img}
                                        title={tile.title}
                                        component="img"
                                    />
                                    <CardContent>
                                        <Typography gutterBottom variant="h5" component="h2">
                                            {tile.title}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary" component="p">
                                            {tile.details}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                                <CardActions>
                                    <Button href={tile.link} target="_blank" size="small" color="primary">
                                        Try it
                                    </Button>
                                    <IconButton aria-label="studio">
                                        <img src={sar} width="25px" alt="Spark AR" />
                                    </IconButton>
                                </CardActions>
                            </Card>
                        </Box>
                    </GridListTile>
                ))}
            </GridList>
        </div>
    );
}